import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

function PortalLoad(props) {
  return (
    <div className="loading-overlay">
      <div className="loading-element">
        <CircularProgress size={50}/>
        <p>
          Please wait...
        </p>
      </div>
    </div>
  );
}

export default PortalLoad;
